import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { FaKey, FaEye, FaEyeSlash, FaLock, FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import Api from "../api/Api";
import "./Modalalterarsenha.css";

// ── Avalia força da senha ──────────────────────────────────────────────────
const calcForca = (senha) => {
  if (!senha) return { nivel: 0, label: "", cor: "" };
  let score = 0;
  if (senha.length >= 6)  score++;
  if (senha.length >= 10) score++;
  if (/[A-Z]/.test(senha)) score++;
  if (/[0-9]/.test(senha)) score++;
  if (/[^A-Za-z0-9]/.test(senha)) score++;

  if (score <= 1) return { nivel: 1, label: "Fraca",    cor: "#ef4444" };
  if (score <= 2) return { nivel: 2, label: "Razoável", cor: "#f97316" };
  if (score <= 3) return { nivel: 3, label: "Boa",      cor: "#eab308" };
  return           { nivel: 4, label: "Forte",   cor: "#22c55e" };
};

// ── Campo de senha com toggle ──────────────────────────────────────────────
const CampoSenha = ({ label, icon, value, onChange, placeholder, disabled }) => {
  const [visivel, setVisivel] = useState(false);
  return (
    <div className="mas-field">
      <label className="mas-label">
        <span className="mas-label-icon">{icon}</span>
        {label}
      </label>
      <div className="mas-input-wrap">
        <input
          type={visivel ? "text" : "password"}
          className="mas-input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoComplete="new-password"
        />
        <button
          type="button"
          className="mas-toggle"
          onClick={() => setVisivel((v) => !v)}
          tabIndex={-1}
        >
          {visivel ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
        </button>
      </div>
    </div>
  );
};

// ── Componente principal ───────────────────────────────────────────────────
const ModalAlterarSenha = ({ open, onClose }) => {
  const [senhaAtual,   setSenhaAtual]   = useState("");
  const [novaSenha,    setNovaSenha]    = useState("");
  const [confirmar,    setConfirmar]    = useState("");
  const [loading,      setLoading]      = useState(false);
  const [sucesso,      setSucesso]      = useState(false);

  const forca = calcForca(novaSenha);
  const match = novaSenha && confirmar && novaSenha === confirmar;
  const noMatch = confirmar && novaSenha !== confirmar;

  // Reset ao fechar
  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setSenhaAtual("");
        setNovaSenha("");
        setConfirmar("");
        setSucesso(false);
      }, 300);
    }
  }, [open]);


    const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const handleSubmit = async () => {
    if (!senhaAtual || !novaSenha || !confirmar) {
      toast.warning("Preencha todos os campos.");
      return;
    }
    if (novaSenha !== confirmar) {
      toast.error("As senhas não coincidem.");
      return;
    }
    if (novaSenha.length < 6) {
      toast.error("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user"));

    setLoading(true);
    try {
      await Api.AlterPassword({
        id:               user.id,
        current_password: senhaAtual,
        password:         novaSenha,
        password_confirmation: confirmar,
      });

      setSucesso(true);
      toast.success("Senha alterada com sucesso!");
      logout();
      setTimeout(() => onClose(), 1800);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.errors?.password?.[0] ||
        "Erro ao alterar a senha.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={420}
      className="mas-modal"
      closeIcon={<span className="mas-close">✕</span>}
      destroyOnClose
    >
      <div className="mas-container">

        {/* ── Cabeçalho ── */}
        <div className="mas-header">
          <div className="mas-header-icon">
            <FaKey size={18} />
          </div>
          <div>
            <h2 className="mas-title">Alterar Senha</h2>
            <p className="mas-subtitle">Defina uma nova senha segura para a sua conta</p>
          </div>
        </div>

        {/* ── Formulário ou estado de sucesso ── */}
        {sucesso ? (
          <div className="mas-success">
            <FaCheckCircle size={40} className="mas-success-icon" />
            <p>Senha alterada com sucesso!</p>
          </div>
        ) : (
          <div className="mas-form">
            <CampoSenha
              label="Senha Atual"
              icon={<FaLock size={11} />}
              value={senhaAtual}
              onChange={(e) => setSenhaAtual(e.target.value)}
              placeholder="Digite a sua senha atual"
              disabled={loading}
            />

            <CampoSenha
              label="Nova Senha"
              icon={<FaKey size={11} />}
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              disabled={loading}
            />

            {/* Barra de força */}
            {novaSenha.length > 0 && (
              <div className="mas-strength">
                <div className="mas-strength-bars">
                  {[1, 2, 3, 4].map((n) => (
                    <div
                      key={n}
                      className="mas-strength-bar"
                      style={{
                        backgroundColor:
                          forca.nivel >= n ? forca.cor : "var(--mas-border)",
                      }}
                    />
                  ))}
                </div>
                <span className="mas-strength-label" style={{ color: forca.cor }}>
                  {forca.label}
                </span>
              </div>
            )}

            <div className="mas-field">
              <label className="mas-label">
                <span className="mas-label-icon"><FaKey size={11} /></span>
                Confirmar Nova Senha
              </label>
              <div className="mas-input-wrap">
                <input
                  type="password"
                  className={`mas-input ${match ? "valid" : ""} ${noMatch ? "invalid" : ""}`}
                  placeholder="Repita a nova senha"
                  value={confirmar}
                  onChange={(e) => setConfirmar(e.target.value)}
                  disabled={loading}
                  autoComplete="new-password"
                />
                {match && (
                  <span className="mas-match-icon">
                    <FaCheckCircle size={14} color="#22c55e" />
                  </span>
                )}
              </div>
              {noMatch && (
                <span className="mas-error-msg">As senhas não coincidem</span>
              )}
            </div>

            {/* ── Botões ── */}
            <div className="mas-actions">
              <button
                className="mas-btn-cancel"
                onClick={onClose}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                className="mas-btn-submit"
                onClick={handleSubmit}
                disabled={loading || noMatch}
              >
                {loading ? (
                  <span className="mas-spinner" />
                ) : (
                  <>
                    <FaKey size={13} />
                    Alterar Senha
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalAlterarSenha;